import { IMerchantData, IWidgetConfigurationData } from '../../interfaces/merchant';
import { FEE_TYPE } from '../../components/application/NewApplication';
import { IFees } from './merchant-interfaces';

const standardFeeDefaultState = {
	feeType: FEE_TYPE.STANDARD,
	feeName: 'FEES.STANDARD',
	description: 'FEES.STANDARD_DESCRIPTION',
	percentage: 0.00,
	feeAmount: 0.00,
	chargeback: 0.00,
	refundFee: 0.00,
	riskFee: 0.00,
	percentageId: '',
	feeAmountId: '',
	chargebackId: '',
	refundFeeId: '',
	riskFeeId: '',
	// interchange: 'Not Included'
};

const nonStandardFeeDefaultState = {
	feeType: FEE_TYPE.NON_STANDARD,
	feeName: 'FEES.NONSTANDARD',
	description: 'FEES.NONSTANDARD_DESCRIPTION',
	percentage: '',
	feeAmount: '',
	minFeeAmount: '',
	chargeback: '',
	refundFee: '',
	riskFee: '',
	percentageId: '',
	feeAmountId: '',
	chargebackId: '',
	refundFeeId: '',
	riskFeeId: '',
	// interchange: 'Not Included'
};

const merchantsLists = {
	countries: [],
	currencies: [],
	states: [],
	businessTypes: [],
	ecommercePlatforms: [],
	industries: [],
	applicationStatuses: [],
	merchantStatuses: [],
	partnerTypes: [],
	ddaType: [],
	cardBrands: [],
	principalTypes: [],
	individualFormOfID: [],
	productSoldFields: [],
	feeTypes: [],
	consumerNotificationChannelValues: [],
	batchTypes: [],
	batchTypes_v2: [],
	integrationTiers: [],
	interchanges: [],
	applicationOperationsStatuses: [],
	applicationRiskStatuses: [],
	acquisitions: [],
	averageChargebackRate: [],
	averageDeclineRate: [],
	averageDisputeRate: [],
	averageProducts: [],
	averageReturnRate: [],
	averageSales: [],
	averageTransactionAmount: [],
	maxSubDuration: [],
	trialPeriod: [],
	urlsRange: [],
	timeInBusiness: [],
	riskCategories: [],
};

const initialCheckoutConfigurations = {
	id: '',
	checkoutPageBackgroundImage: '',
	checkoutPagePrimaryColor: '',
	checkoutPageSecondaryColor: '',
	checkoutPageFontColor: '',
	logoFile: '',
	favicon: '',
	isCheckoutOneColumn: false,
};

export const initialState = {
	merchantStatus: null,
	confirmApplicationData: [],
	isConfirmApplicationDataLoading: true,
	isMerchantListsLoading: true,
	feeTableData: {
		feeName: '',
		description: 'Interchange+',
		percentage: 0,
		feeAmount: 0,
		chargeback: 0
	},
	merchantsLists,
	widgetConfigurationData: {} as IWidgetConfigurationData,
	isWidgetConfigurationDataLoading: false,
	merchantData: {} as IMerchantData,
	merchantFees: [],
	defaultFees: [],
	allDefaultFees: [],
	isMerchantDataLoading: true,
	standardFees: standardFeeDefaultState,
	merchantFee: nonStandardFeeDefaultState,
	feesArray: [],
	historyFeesData: [],
	isIntegrationPartnersListSelectorLoading: false,
	integrationPartnersListSelector: [],
	isWhitelabelPartnersListSelectorLoading: false,
	whitelabelPartnersListSelector: [],
	partnersListSelector: [],
	salesAgencyListSelector: [],
	partnersList: [],
	isPartnerListLoading: true,
	isMerchantDataSaving: false,
	applicationData: null,
	isApplicationDataLoading: true,
	isStandardFeeSelected: true,
	merchantsListReport: [],
	merchantsListReportData: null,
	isSavingNewPartner: false,
	generalError: '',
	sitesList: [],
	isSitesListLoading: false,
	isWebhookEventTypesLoading: false,
	webhookEventTypes: [],
	webhooksLogData: null,
	webhooksLogTotalItemCount: 0,
	webhooksLogTablePageNumber: 0,
	webhooksLogTablePageSize: 10,
	isWebhooksLogDataLoading: false,
	listOfMerchants: [],
	isListOfMerchantsLoading: false,
	chosenMerchant: '',
	isGlobalTransparentLoader: false,
	checkoutConfiguration: initialCheckoutConfigurations,
	isCheckoutConfigurationLoading: false,
	mccList: [],
	sftpConfig: {},
	isSftpLoading: false,
	agenciesList: [],
	isAgenciesListLoading: true,
	isSavingNewAgency: false,
	isSavingNewSalesAgent: false,
	merchantNames: {},
	partnerNames: null,
	isPartnerNamesListLoading: false,
	senseJSValidationResult: null,
	isSenseJSValidationLoading: false,
	accountList: [],
	isAccountListLoading: false,
	isAddNewAccountLoading: false,
	accountListSelector: [],
	fundsReserveConfigActiveListData: [],
	fundsReserveConfigInActiveListData: [],
	isFundsReserveConfigListDataLoading: false,
	isFundsReserveConfigActiveListDataLoading: false,
	isFundsReserveConfigInactiveListDataLoading: false,
	fundsReserveConfigLists: {},
	platformSystem: '',
	isMerchantFundsReserveConfigLoading: false,
	partnerFees: [],
	isPartnerFeesLoading: false,
	isPartnerFeesAddingLoading: false,
	partnerBankDetails: null,
	isPartnerBankDetailsLoading: false,
	auditLogsList: [],
	isAuditLogsListLoading: false,
	auditLogsListTotalItemCount: 0,
	auditLogsListTablePageNumber: 0,
	auditLogsListTablePageSize: 10,
	status: '1',
	pid: '',
	integrationPartnerId: '',
	q: '',
	signUpLoading: false,
	isConfirmAgreement: false,
	isQuickApplicationLoading: false,
	type: '',
	quickApplicationData: null,
	isQuickApplicationDataLoading: false,
	applicationSummary: [],
	isApplicationSummaryLoading: false,
	isApplicationViewDataLoading: true,
	applicationViewData: null,
	applicationViewFees: null,
	isSavingApplicationViewDataLoading: false,
	isApplicationViewDataSubmissionLoading: false,
	workflows: {},
	workflowsData: [],
	isWorkflowsLoading: false,
	applicationFormEditStatus: false,
	isRiskRequestLoading: false,
	isReinviteLoading: false,
	isDocumentLoading: false,
	applicationDetailsLogs: [],
	isApplicationDetailsLogsLoading: false,
	isPartnerDetailsDataLoading: true,
	partnerDetailsData: null,
	crmId: '',
};

export enum feeDataTypes {
	PERCENTAGE = 'Percentage',
	FEE_AMOUNT = 'Fee Amount',
	MIN_FEE_AMOUNT = 'Min Fee Amount',
	CHARGEBACK = 'Chargeback Fee',
	REFUND_FEE = 'Refund Fee',
	RISK_FEE = 'Risk Fee',
}

export const feesNames = [
	feeDataTypes.FEE_AMOUNT,
	feeDataTypes.MIN_FEE_AMOUNT,
	feeDataTypes.PERCENTAGE,
	feeDataTypes.CHARGEBACK,
	feeDataTypes.REFUND_FEE,
	feeDataTypes.RISK_FEE,
];

export const feesList = (data): IFees[] => {
	return feesNames
		?.map(el => {
			const newEl = data?.find(item => item?.name === el);
			if (newEl) {
				return {
					name: newEl?.name,
					amount: newEl?.amount / 100,
					minimumFeeAmount: newEl?.minimumFeeAmount ? newEl?.minimumFeeAmount / 100 : '',
					id: newEl?.id,
				};
			}
		})
		?.filter(el => !!el);
};

export const getFormattedFeeList = (data): IFees[] => (
	data?.map(fee => ({
		name: fee?.name,
		amount: fee?.amount / 100,
		minimumFeeAmount: fee.minimumFeeAmount ? fee.minimumFeeAmount / 100 : '',
		id: fee?.id,
	}))
);
